module.exports = __webpack_public_path__ + "img/Samar-Shousher.49dd62bc.png";